import styled from "styled-components";

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   &.rag {
      min-width: 300px;
      .select {
         margin-bottom: 10px;
         h4 { width: 80px; }
      }
      .textarea {
         margin-bottom: 10px;
         margin-top: 35px;

         > div {
            height: 80px;
            min-height: 80px;
         }
      }
      .textInput {
         margin-bottom: 10px;
         h4 { width: 100px; }

         &:last-of-type {
            margin-bottom: 0;
         }
      }
   }
   /* &.uploader {
      min-width: 280px;
   } */
   .upload {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgb(245, 245, 245);
      border: 2px dashed rgb(220, 220, 220);
      height: 60px;
      border-radius: 15px;
      margin-bottom: 15px;
      transition: all .2s ease-in-out;

      svg {
         font-size: 30px;
         margin-right: 7.5px;
         opacity: 0.2;
      }
      span { opacity: 0.4; }
      input {
         position: absolute;
         width: 100%;
         height: 100%;
         opacity: 0;
         cursor: pointer;
      }
      &:hover, &.focus {
         border-color: #1E272E;
      }
   }
   .files {
      .title {
         font-size: 15px;
         color: #1E272E;
         align-items: center;
         display: flex;

         h4 { 
            font-weight: 400; 
            margin-right: 7.5px; 
         }
         span { 
            opacity: 0.5; 
         }
         .limit {
            font-size: 13px;
            opacity: 0.5; 
         }
      }
      ul {
         margin-top: 7.5px;
         overflow: auto;
         max-height: 150px;

         li {
            position: relative;
            display: flex;
            align-items: center;

            &:not(:last-of-type) {
               margin-bottom: 5px;
               border-radius: 5px;
            }
            &.green {
               .name {
                  background-color: rgba(51, 153, 102, 0.15);
               }
               .name .remove {
                  background-color: transparent !important;
               }
            }
            .name {
               position: relative;
               display: block;
               opacity: 0.8;
               white-space: nowrap;
               overflow: hidden;
               text-overflow: ellipsis;
               background-color: #F6F6F6;
               padding: 5px 20px 5px 10px;
               font-size: 16px;
               border-radius: 5px;
               width: 100%;

               .remove {
                  position: absolute;
                  top: 0;
                  right: 0;
                  display: none;
                  align-items: center;
                  justify-content: center;
                  padding: 0 10px;
                  height: 100%;
                  color: #F05454;
                  transition: all .2s ease-in-out;
                  background-color: #F6F6F6;
                  cursor: pointer;
                  font-size: 18px;

                  &:hover {
                     opacity: 0.7;
                  }
               }
               &:hover .remove {
                  display: flex;
               }
            }
            .chunk {
               padding: 5px 10px;
               font-size: 16px;
               border-radius: 5px;
               margin-left: 7.5px;
               transition: all .2s ease-in-out;
               cursor: pointer;
               background-color: #3E82F8;
               font-size: 15px;
               color: #fff;
               border: none;

               &.active {
                  background-color: rgb(51, 153, 102);
               }
               &:disabled {
                  opacity: 0.65;
                  cursor: default;

                  &:hover {
                     opacity: 0.65;
                  }
               }
               &:hover {
                  opacity: 0.8;
               }
            }
         }
      }
   }
   .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #F6F6F6;
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      padding: 7.5px 15px;
      font-size: 15px;

      > div {
         display: flex;
         justify-content: center;
         align-items: center;
         width: 150px;
         margin-bottom: 3px;

         span:first-of-type {
            width: 10px;
            height: 10px;
            background-color: #339966;
            margin-right: 7.5px;
            border-radius: 2px;
            box-shadow: 0 0 3px #339966;
         }
         span:last-of-type {
            opacity: 0.85;
         }
      }
      > span { opacity: 0.85; }
   }
   .filesEdit {
      top: 0 !important;
      right: calc(100% + 22px) !important;
      width: 190px !important;
      height: auto !important;
      max-height: 200px;

      .checkbox {
         height: auto !important;
         max-height: 186px;

         > div label {
            width: calc(240px - 17px - 10px - 15px) !important;
         }
      }
   }
`;